import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Images } from 'src/app/models/interfaces/images';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Directory } from './directory-image/directory';
import { ApiImageService } from './api-image.service';

@Component({
  selector: 'app-repository-image',
  templateUrl: 'repository-image.component.html',
  styleUrls: ['repository-image.component.css'],
})
export class RepositoryImageComponent implements OnChanges, OnInit {
  constructor(
    private api: ApiImageService,
    private modal: NgbModal,
    private toast: ToastrService,
  ) { }
  level: any;
  domain: string = this.api.domain;
  allDirectories: Directory[] = [];
  hoveredDirectory: any;
  directoryIdSelected: number = 0;
  
  @Input()
  showCursor:boolean=false;
  @Output()
  onSelected = new EventEmitter<Images>();

  showCopyInput: boolean = false;
  ngOnInit(): void {
    this.getImages(this.directoryIdSelected);
    this.level = sessionStorage.getItem('ccviLevel')
      ? sessionStorage.getItem('ccviLevel')
      : 0;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.getImages(0);
    if (changes['allDirectories']!=null && changes['allDirectories'].currentValue!=changes['allDirectories'].previousValue) {
      console.log("cambio DIR:", this.allDirectories);
    }
  }

  form = new UntypedFormGroup({
    id: new UntypedFormControl(),
    alt: new UntypedFormControl(),
    directory_id: new UntypedFormControl()
  });

  pathFull: string = '';
  idSeledted: number = 0;
  items!: Images[];

  openModal(idMdl: any, item: Images) {
    var link = this.domain + 'img/upload/' + item.path + '/' + item.name;
    this.modal.open(idMdl);
    this.pathFull = link;
  }
  getImages(directory_id: number) {
    this.api.getImages(directory_id).subscribe(
      (response) => {
        this.items = response.data as Images[];
      },
      (e) => {
        this.items = null;
      }
    );
  }
  saveAlt(value: any, id: number) {
    this.form.get('id').setValue(id);
    this.form.get('alt').setValue(value);
    this.api.updateImage(this.form).subscribe(
      (response) => {
        this.toast.success('Agregado correctamente', 'Atributo ALT');
        this.getImages(this.directoryIdSelected);
      },
      (error) => {
        this.toast.warning('No fue posible agregar o modificars', 'Atributo ALT');
      }
    );
  }
  delete(item: Images) {
    this.api.deleteImage(item.id).subscribe(
      (response) => {
        this.toast.success('La imagen seleccionada fue eliminada', 'Imagenes');
        this.getImages(this.directoryIdSelected);
      },
      (error) => {
        this.toast.warning(
          'La imagen seleccionada, no fue eliminada',
          'Imagenes'
        );
      }
    );
  }
  showCopyLink(show: boolean) {
    console.log('es:' + show);
  }
  selectedImage(item: Images) {
    var link = this.domain + 'img/upload/' + item.path + '/' + item.name;
    item.link = link;
    this.onSelected.emit(item);
  }

  getDownloadImage() {
    return this.api.getImage(this.idSeledted);
  }
  onSuccess(rs: any) {
    if (rs) {
      this.getImages(this.directoryIdSelected);
      this.toast.success('Imagen subida correctamente', 'Subida de imagen');
    }
  }
  // En tu clase RepositoryImageComponent

  copyToClipboard(item: Images): void {
    const imageUrl = this.domain + 'img/upload/' + item.path + '/' + item.name;
    navigator.clipboard.writeText(imageUrl).then(
      () => {
        // Notificar al usuario que se ha copiado al portapapeles
        this.toast.success('URL copiada al portapapeles', 'Copiar URL');
      },
      (err) => {
        // Notificar al usuario en caso de un error
        console.error('Error al copiar la URL al portapapeles', err);
        this.toast.error('No se pudo copiar la URL', 'Error');
      }
    );
  }
  moveImage(image: Images, directory: Directory) {
    console.log("Moviendo imagen a directorio");
    this.form.get('id').setValue(image?.id);
    this.form.get('directory_id').setValue(directory?.id);
    this.api.updateImage(this.form).subscribe(
      (response) => {
        this.toast.success('Imagen movida corectamente');
        this.getImages(this.directoryIdSelected);
      },
      (error) => {
        this.toast.warning('No fue posible mover la imagen');
      }
    );

  }
  mouseOver(directory: Directory) {
    console.log("mouse over", directory);
    this.hoveredDirectory = directory;
  }
  getIconClass(directory: any): string {
    return this.hoveredDirectory === directory ? 'fa-solid fa-folder-open text-warning' : 'fa-solid fa-folder';
  }
}
